import AddPost from './AddPost/AddPost.js'
import PostList from './PostsList/PostsList.js'

export default function Homepage() {
    return(
        <>
            <AddPost></AddPost>
            <PostList></PostList>
        </>
    )
}